/*
Replace
ingredient with your resource Name :) Take care about different writings!
/!\ Ingredient ingredient Ingredients ingredients /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const ingredientSlice = createSlice({
  name: "ingredients",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listIngredients,
  show: showIngredient,
  create: createIngredient,
  update: updateIngredient,
} = ingredientSlice.actions;

export const actions = ingredientSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const ingredients = (state) =>
  state.ingredients.idsList.map((id) => state.ingredients.dictionary[id]);
export const ingredient = (state) =>
  state.ingredients.showId &&
  state.ingredients.dictionary[state.ingredients.showId];
export const ingredientAttributes = (state) => ingredient(state)?.attributes;
export const ingredientRelationships = (state) =>
  ingredient(state)?.relationships;
export const ingredientId = (state) => state.ingredients.showId;

export const getIngredient = createSelector(
  (state) => state.ingredients.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getIngredientAttributes = createSelector(
  (state) => state.ingredients.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getIngredientRelationships = createSelector(
  (state) => state.ingredients.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getIngredients = createSelector(
  (state) => state.ingredients.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default ingredientSlice.reducer;
